// core/api/api-endpoints.token.ts
import { InjectionToken } from '@angular/core';
import { LookupKey } from '../../shared/constants/lookup-keys';

export interface ApiEndpoints {
    users: {
        list: string;
        detail: (id: string) => string;
    };
}

export const API_ENDPOINTS = new InjectionToken<ApiEndpoints>('API_ENDPOINTS', {
    providedIn: 'root',
    // This method is used to factory
    factory: () => ({
        users: {
            list: '/users',
            // This method is used to detail using id
            detail: (id: string) => `/users/${id}`
        },
        lookup: {
            [LookupKey.LOOKUP_URL]: 'ListOfValues_REST/GetListOfValues',
            [LookupKey.ACTIVITIES_URL]: 'ActivityCode_REST/ActivityCode'
        },
    })
});
